import { useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { chevronForwardOutline, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { Component }  from 'react';

import Vault from '../components/Vault';
import NServer from "../components/NServer";

import '../pages/Main.css'; 

  
const TitleContent : React.FC<ContentInterface> = ({ content }) => {
    
    const router = useIonRouter();

    // click on love icon
    const onLike = async () => {
        router.push("/token/wallet", "forward", "push");
    }

    // click on avatar
    const onAvatar = () => {
        router.push("/settings", "forward", "push");
    }

    return (
        <div className="title-content">
            <IonToolbar className="content-wrapper">
                <IonImg slot="start" className="title-img" src="assets/img/header.png"/>
                <IonChip slot="end" onClick={onLike}>
                    <IonIcon icon={heart} color="primary"></IonIcon>
                    <IonLabel>{ content.user_name }</IonLabel>
                </IonChip>
                <IonAvatar className="avatar-top" slot="end" onClick={onAvatar}>
                    <img src={content.user_avatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/avt.jpg' } } />
                </IonAvatar>
            </IonToolbar>
        </div>
    );
};
  
export default TitleContent;